import CardsOptions from '../Cards/CardsOptions'
import type { PresentationBlock } from 'paintscout'

interface TestimonialsOptionsProps {
  block: PresentationBlock
  handleOptionFieldChange: (field: string, value: any) => void
}

function TestimonialsOptions(props: TestimonialsOptionsProps) {
  return CardsOptions({ type: 'testimonials', ...props })
}

export default TestimonialsOptions
